<template>
  <div v-if="!dialogFormVisible" class="produce_pup">
    <el-dialog
      v-if="dialogVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      style="height: 100%"
      center
      :title="title"
      :visible.sync="dialogVisible"
      width="756px"
      @close="close"
    >
      <div v-loading = "loading">
        <el-form ref="form" :model="form" label-width="100px" :rules="rules">
          <el-form-item label="化学品:" prop="hxpBm">
            <el-cascader
              v-if="!(scrktype || bgdisable)"
              v-model="form.hxpBm"
              :disabled="scrktype || bgdisable"
              style="width: 407px"
              placeholder="请选择化学品"
              :options="options3"
              @change="handleChange"
            />
            <!--查看显示名字即可-->
            <el-input v-else v-model="form.hxpMc" disabled style="width: 407px" />
          </el-form-item>
          <el-form-item label="存放仓库:" prop="ckId">
            <el-select
              v-if="!scrktype"
              v-model="form.ckId"
              :disabled="scrktype"
              placeholder="请选择"
              style="width: 407px"
              @change="ckChange"
            >
              <el-option
                v-for="item in options1"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
            <!--查看显示名字即可-->
            <el-input v-else v-model="form.ckmc" disabled style="width: 407px" />
          </el-form-item>
          <el-form-item label="经办人:" prop="jbrId">
            <!--新增和编辑时，需要可切换选择-->
            <el-select
              v-if="!(scrktype || bgdisable)"
              v-model="form.jbrId"
              filterable
              :disabled="scrktype || bgdisable"
              placeholder="请选择"
              style="width: 407px"
              @change="jbrChange"
            >
              <el-option
                v-for="item in options2"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
            <!--查看和变更时，显示名字即可-->
            <el-input v-else v-model="form.jbrName" disabled style="width: 407px" />
          </el-form-item>
          <el-form-item label="入库数量:" prop="rksl">
            <div style="width: 407px">
              <el-input
                v-model="form.rksl"
                :disabled="scrktype"
                placeholder="请输入"
                style="width: 245px; margin-right: 5px"
              />

              <el-select
                v-model="form.rkslDw"
                :disabled="scrktype"
                style="width: calc(407px - 245px - 5px)"
                placeholder="单位"
              >
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </div>
          </el-form-item>
          <el-form-item label="保管员姓名:">
            <el-input
              v-model="form.bgyxm"
              disabled
              style="width: 407px"
            />
          </el-form-item>
          <el-form-item label="保管员电话:">
            <el-input
              v-model="form.bgydh"
              disabled
              style="width: 407px"
            />
          </el-form-item>
          <el-form-item label="生产日期:" prop="scrq">
            <el-date-picker
              v-model="form.scrq"
              :picker-options="pickerBeginDateBefore"
              type="date"
              style="width: 407px"
              placeholder="选择日期"
              :disabled="scrktype"
              value-format="yyyy-MM-dd"
            />
          </el-form-item>
          <el-form-item v-if="djsjdisable" label="登记时间:" prop="djsj">
            <el-date-picker
              v-model="form.djsj"
              type="date"
              style="width: 407px"
              placeholder="选择日期"
              disabled
              format="yyyy-MM-dd HH:mm:ss"
            />
          </el-form-item>
          <el-form-item v-else label="登记时间:">
            <el-date-picker
              :value="new Date()"
              type="date"
              style="width: 407px"
              placeholder="选择日期"
              disabled
              format="yyyy-MM-dd HH:mm:ss"
            />
          </el-form-item>
          <el-form-item v-if="leixing == 'add'" label="登记人:">
            <el-input v-model="djr" disabled style="width: 407px" />
          </el-form-item>
          <el-form-item v-else label="登记人:">
            <el-input
              v-model="form.djrLabel"
              disabled
              style="width: 407px"
            />
          </el-form-item>
          <el-form-item
            label="备注:"
            prop="bz"
            :rules="{
              validator: (rule, value, callback) => {
                lengthValidate(rule, value, callback, 'xt', 225);
              },
              trigger: ['blur', 'change'],
            }"
          >
            <el-input
              v-model="form.bz"
              type="textarea"
              :rows="3"
              resize="none"
              style="width: 407px"
              placeholder="请输入"
              :disabled="scrktype || changeType || bgdisable"
            />
          </el-form-item>

          <el-form-item
            v-if="bgdisable"
            label="变更理由:"
            prop="bgly"
            :rules="{
              required: true,
              validator: (rule, value, callback) => {
                lengthValidate(rule, value, callback, 'bt', 1000);
              },
              trigger: ['blur', 'change'],
            }"
          >
            <el-input
              v-model="form.bgly"
              type="textarea"
              :rows="3"
              resize="none"
              style="width: 407px"
              placeholder="请输入"
              :disabled="scrktype"
            />
          </el-form-item>
        </el-form>
      </div>
      <div v-loading = "loading" v-if="leixing == 'ck' || leixing == 'change'">
        <bgcsOfDetail
          v-if="curRowObj.bgcs > 0"
          :cur-row-obj="curRowObj"
          :cur-type="curType"
          :bgcs-t-k-name="'生产入库'"
          @bacsCkXqShow="bacsCkXqShow"
        />
      </div>

      <!-- 新增 -->
      <div v-loading = "loading"
        v-if="leixing == 'edit' || leixing == 'add'"
        slot="footer"
        class="buttonList"
      >
        <el-button
          size="medium"
          type="primary"
          style="margin-bottom: 17px"
          @click="submitFormTemp('form')"
        >暂时保存</el-button>
        <el-button
          size="medium"
          type="primary"
          @click="submitForm('form', 'tj')"
        >入库</el-button>
      </div>

      <!-- 查看 -->
      <div v-if="leixing == 'ck'" slot="footer" class="XINbuttonList">
        <el-button
          size="medium"
          type="primary"
          @click="submitForm('form')"
        >确定</el-button>
      </div>
      <!-- 变更 -->
      <div v-loading = "loading" v-if="leixing == 'change'" slot="footer" class="XINbuttonList">
        <el-button
          size="medium"
          type="primary"
          @click="submitForm('form', 'bg')"
        >提交变更</el-button>
      </div>
    </el-dialog>
  </div>

  <div v-else class="produce_pup">
    <!-- 详情弹框 -->
    <el-dialog :visible.sync="dialogFormVisible" width="1200px" center>
      <bgxqCom
        v-if="dialogFormVisible"
        :bgcs-t-k-name="bgcsTKName"
        :dgcs-xq-id="dgcsXqId"
      />
      <div slot="footer" class="dialog-footer">
        <el-button
          v-preventReClick
          type="primary"
          style="background-color: #4170ff; border: none"
          @click="dialogFormVisible = false"
        >确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { lengthValidate } from '@/assets/js/validate'
import bgxqCom from '../bgxq/bgxqCom.vue'

import {
  scrkhxpMes,
  getnbsyckMes,
  lyrOptions,
  addoreditscrkMes,
  changescrkMes,
  changeYzscrkMes, addoreditscrkMesTemp
} from '@/assets/js/common.js'
import { getdwforhxpBm } from '@/assets/js/yssq'
import bgcsOfDetail from '../bgxq/bgInDetail.vue'
import {dealDataGy} from "@/utils/ppp";
export default {
  components: {
    bgcsOfDetail,
    bgxqCom
  },
  props: {
    scrktype: {
      type: Boolean
    },
    djsjdisable: {
      type: Boolean
    },
    bgdisable: {
      type: Boolean
    },
    leixing: {
      type: String
    },
    changeType: {
      type: Boolean
    },
    djr: {
      type: String
    }
  },
  data() {
    const rkslxg = (rule, value, callback) => {
      if (this.leixing == 'ck') {
        callback()
      }
      if (!(this.form.rksl + '')) {
        callback(new Error('请填写入库数量值'))
      }
      //  else if (this.form.rksl < 0) {
      //   callback(new Error("请填写不小于0的入库数量值"));
      // }
      const reg = /^(0|[1-9][0-9]*)(\.\d+)?$/

      if (this.leixing != 'change' && !reg.test(this.form.rksl)) {
        callback(new Error('请输入大于或等于0的数量值'))
      } else if (
        /^-?[1-9]\d{0,8}(\.\d{1,3})?$|^-?0(\.\d{1,3})?$/.test(value) == false
      ) {
        return callback(new Error('整数位最大长度9位,保留3位小数'))
      } else if (!this.form.rkslDw) {
        callback(new Error('请选择单位'))
      } else {
        callback()
      }
    }
    return {
      loading: false,
      dgcsXqId: null,
      dialogFormVisible: false,
      curType: '',
      curRowObj: {}, // 当前行的对象
      bgcsTKName: '生产入库',
      bgwindow: false,
      // 日期限制
      pickerBeginDateBefore: {
        disabledDate(time) {
          return time.getTime() > Date.now()
        }
      },
      title: '新增生产入库',
      dialogVisible: false,
      form: {
        hxpBm: '',
        hxpMc: '',
        ckId: '',
        ckmc: '',
        jbrId: '',
        jbrName: '',
        rksl: '',
        rkslDw: '',
        bgyId: '',
        bgyxm: '',
        bgydh: '',
        zt: '',
        scrq: '',
        bz: '',
        djsj: '',
        bgly: '',
        djrLabel: ''
      },
      rules: {
        hxpBm: [
          { required: true, message: '请选择', trigger: ['blur', 'change'] }
        ],
        ckId: [
          { required: true, message: '请选择', trigger: ['blur', 'change'] }
        ],
        jbrId: [
          { required: true, message: '请选择', trigger: ['blur', 'change'] }
        ],
        rksl: [
          { required: true, validator: rkslxg, trigger: ['blur', 'change'] }
        ],
        scrq: [
          { required: true, message: '请选择', trigger: ['blur', 'change'] }
        ],
        djsj: [
          { required: true, message: '请选择', trigger: ['blur', 'change'] }
        ]
        // bgly: [
        //   {
        //     required: true,
        //     message: "请输入变更理由",
        //     trigger: ["blur", "change"],
        //   },
        // ],
      },
      options: [],
      options1: [], // 仓库
      options2: [], // jingbr
      options3: [], // 获取化学品级联数据
      id: '',
      zt: ''
    }
  },
  computed: {},
  watch: {
    form: {
      deep: true,
      handler(val) {
        if (val.hxpBm) {
          getdwforhxpBm(this.form.hxpBm).then((e) => {
            this.options = e.data.data
          })
        } else this.options = []
      }
    }
  },

  created() {
    scrkhxpMes().then((e) => {
      this.options3 = e.data.data
    })
  },
  beforeDestroy() {
    this.$bus.$off('fatherToChil')
  },
  mounted() {
    this.$nextTick(() => {
      this.$bus.on('fatherToChil', this.initCon)
    })
  },
  methods: {
    lengthValidate,
    bacsCkXqShow(id) {
      this.dgcsXqId = id
      this.dialogFormVisible = !this.dialogFormVisible
    },
    initCon(curRow, curType) {
      this.curRowObj = curRow
      this.curType = curType
    },
    // 关闭窗口
    handleCloseBindWarnStandard() {
      this.bgwindow = false
    },
    jbrChange(val) {
      this.options2.forEach((item) => {
        if (item.value == val) {
          this.form.jbrName = item.label
        }
      })
    },
    // 仓库改变
    ckChange(val) {
      this.options1.forEach((item) => {
        if (item.value == val) {
          this.form.bgyId = item.ckbgyId
          this.form.bgyxm = item.ckbgy
          this.form.bgydh = item.ckbgyDh
          this.form.ckmc = item.label
        }
      })
    },
    // 化学品级联改变
    handleChange(value) {
      if (value == undefined) return
      this.form.rkslDw = ''
      this.form.hxpBm = value.slice(-1).toString()
    },
    reset() {
      this.form = {
        hxpBm: '',
        ckId: '',
        ckmc: '',
        jbrId: '',
        jbrName: '',
        rksl: '',
        rkslDw: '',
        bgyId: '',
        bgyxm: '',
        bgydh: '',
        zt: '',
        scrq: '',
        bz: '',
        djsj: '',
        bgly: '',
        djrLabel: ''
      }

      this.$refs['form'].clearValidate(['rksl'])
      this.$refs['form'].resetFields()
      this.dialogVisible = false
    },
    //加载仓库和经办人信息
    getCkxxAndJbr(dataMes,type){
      if(type == 'change'){
        getnbsyckMes(dataMes.ckId).then((e) => {
          this.options1 = e.data.data
          this.form.ckId = dataMes.ckId
          this.form.ckmc = dataMes.ckmc
        })
      }else{
        getnbsyckMes().then((e) => {
          this.options1 = e.data.data
          if (dataMes && dataMes.ckId) {
            this.options1.findIndex((item) => {
              if(item.value == dataMes.ckId){
                this.form.ckId = dataMes.ckId
                this.form.ckmc = dataMes.ckmc
                this.form.bgyId = dataMes.bgyId
                this.form.bgydh = dataMes.bgydh
                this.form.bgyxm = dataMes.bgyxm
                return
              }
            })
          }
        })
        lyrOptions().then((e) => {
          this.options2 = e.data.data
          if(dataMes && dataMes.jbrId){
            this.options2.findIndex((item) => {
              if(item.value == dataMes.jbrId){
                this.form.jbrId = dataMes.jbrId
                this.form.jbrName = dataMes.jbrName
                return
              }
            })
          }
        })
      }
    },
    getformMes(dataMes, type) {
      this.id = type == 'edit' || type == 'change' ? dataMes.id : '' // 根据id来知道编辑的数据
      this.form = Object.assign(
        {},
        {
          hxpBm: dataMes.hxpBm,
          hxpMc: dataMes.hxpMc,
          ckId: '',
          ckmc: '',
          rksl: dataMes.rksl,
          rkslDw: dataMes.rkslDw,
          zt: dataMes.zt,
          scrq: dataMes.scrq,
          bz: dataMes.bz,
          bgyId: type == 'change'?dataMes.bgyId:'',
          bgyxm: type == 'change'?dataMes.bgyxm:'',
          bgydh: type == 'change'?dataMes.bgydh:'',
          jbrId: type == 'change'?dataMes.jbrId:'',
          jbrName: type == 'change'?dataMes.jbrName:'',
          djsj: dataMes.djsj,
          djrLabel: dataMes.djrLabel,
          bgly: dataMes.bgly
        }
      )
      this.getCkxxAndJbr(dataMes,type)
      this.$nextTick(() => {
        this.$refs.form.clearValidate() //清楚页面所有校验结果
      })
    },
    async addoreditscrkMess(dataObj) {
      this.loading = true
      dataObj.vdata = await dealDataGy()
      addoreditscrkMes(dataObj).then((e) => {
        this.loading = false
        this.$message.success('提交成功!')
        this.reset()
        this.$parent.search()
      }).catch((error) => {
        this.loading = false
      })
    },
    changeYzscrkMess(dataObj) {
      changeYzscrkMes(dataObj).then((e) => {
        var data = '是否确认变更?'
        if (e.data.data.type == 'success') {
        } else {
          data =
            "<span style='color:red'>" +
            e.data.data.msg +
            '</span>是否确认变更?'
        }
        this.$confirm(data, {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          dangerouslyUseHTMLString: true,
          type: 'warning',
          center: true
        }).then(() => {
          this.loading = true
          changescrkMes(dataObj).then((e) => {
            this.loading = false
            this.$message.success('变更成功!')
            this.$parent.search()
            this.reset()
          }).catch((error) => {
            this.loading = false
          })
        })
      })
    },
// 提交表单内容（暂时保存，取消校验）
    submitFormTemp() {
      if (this.scrktype) {
        this.reset()
        return
      }

      this.zt = '00'
      var data = {
        id: this.leixing == 'add' ? '' : this.id,
        hxpBm: this.form.hxpBm,
        ckId: this.form.ckId,
        ckmc: this.form.ckmc,
        rksl: this.form.rksl,
        rkslDw: this.form.rkslDw,
        zt: this.zt,
        scrq: this.form.scrq,
        bz: this.form.bz,
        bgyId: this.form.bgyId,
        bgyxm: this.form.bgyxm,
        bgydh: this.form.bgydh,
        jbrId: this.form.jbrId,
        jbrName: this.form.jbrName,
        bgly: this.form.bgly,
        djrLabel: this.form.djrLabel
      }
      this.$confirm('此操作将暂时保存该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true
      }).then(async () => {
        this.loading = true
        data.vdata = await dealDataGy()
        addoreditscrkMesTemp(data).then((e) => {
          this.loading = false
          this.$message.success('提交成功!')
          this.reset()
          this.$parent.search()
        }).catch((error) => {
          this.loading = false
        })
      })
    },
    // 提交表单内容（提交申请）
    submitForm(formName, type) {
      if (this.scrktype) {
        this.reset()
        return
      }

      // 编辑和复制新增需要验证
      this.$refs[formName].validate((valid, obj) => {
        if (valid) {
          this.zt = type == 'zsbc' ? '00' : '01'
          var data = {
            id: this.leixing == 'add' ? '' : this.id,
            hxpBm: this.form.hxpBm,
            ckId: this.form.ckId,
            ckmc: this.form.ckmc,
            rksl: this.form.rksl,
            rkslDw: this.form.rkslDw,
            zt: this.zt,
            scrq: this.form.scrq,
            bz: this.form.bz,
            bgyId: this.form.bgyId,
            bgyxm: this.form.bgyxm,
            bgydh: this.form.bgydh,
            jbrId: this.form.jbrId,
            jbrName: this.form.jbrName,
            bgly: this.form.bgly,
            djrLabel: this.form.djrLabel
          }

          if (type == 'tj') {
            this.$confirm('此操作将保存该数据，不可撤回, 是否继续?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning',
              center: true
            }).then(() => {
              this.addoreditscrkMess(data)
            })
          } else if (type == 'zsbc') {
            this.$confirm('此操作将暂时保存该数据, 是否继续?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning',
              center: true
            }).then(() => {
              this.addoreditscrkMess(data)
            })
          } else if (type == 'bg') {
            this.changeYzscrkMess(data)
          } else {
            this.reset()
          }
        } else {
          return false
        }
      })
    },
    close() {
      this.reset()
    }
  }
}
</script>
<style scoped lang="less">
.produce_pup {
  .el-form {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  p {
    margin: 0;
    text-align: center;
    color: red;
  }
  /deep/.el-dialog__header {
    padding: 40px 20px 10px !important;
    .el-dialog__title {
      width: 120px;
      height: 28px;
      font-size: 20px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #434343;
      line-height: 28px;
    }
    .el-dialog__close {
      color: #000000 !important;
      font-weight: bold;
    }
  }
  .buttonList {
    .el-button--primary:nth-child(1) {
      width: 110px;
      height: 42px;
      background: #ebebeb;
      border-radius: 5px;
      border-color: #ebebeb;
      color: #333333;
      margin-right: 228px;
    }
    .el-button--primary:nth-child(2),
    .el-button--primary:nth-child(3) {
      width: 110px;
      height: 42px;
      background: #4170ff;
      border-color: #4170ff;
      border-radius: 5px;
      margin-bottom: 17px;
    }
  }
  .XINbuttonList {
    width: 498px;
    margin-left: auto;
    margin-right: auto;
    margin-top: 40px;
    margin-bottom: 45px;
    text-align: center;
    .el-button {
      background-color: #4170ff;
      color: white;
      width: 110px;
      height: 42px;
      border: none;
    }
  }
}
/deep/.el-dialog--center .el-dialog__body {
  text-align: initial;
  padding: 25px 25px 0;
}
</style>
